import React from "react";
import {Outlet} from "react-router-dom";
import {WaterMark} from "@ant-design/pro-layout";

const LoginTemplate = () => {
    return (
        <>
            <WaterMark content={""} gapX={50} gapY={100}>
                <div style={{minHeight: '100vh'}}>
                    <Outlet/>
                </div>
            </WaterMark>
        </>
    )
}

export default LoginTemplate